import type { Country } from 'types/cms/Country';
import type { SiteLocale } from 'types/localisation/SiteLocale';

export const mapCountryToLocale = (country: Country): SiteLocale => ({
  countryCode: country.isoCode,
  countryName: country.name,
  currencyCode: country.currency.isoCode,
});
